import React  from "react";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Activity() {

    AnimationFileLoader();

  return (
    <>
 
    {/* Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/* End Author */}

    {/* Activity Feed */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    {/* Section Title */}
                    <div className="section-title text-white text-center mb-35">
                        <h2>Activity Feed</h2>
                        <p>The top NFTs on Anefty, ranked by volume, floor price and other statistics. "Multiple" if you
                            want to sell by ones collectibles upload your work likes image, video, audio times for
                            Anefty.</p>
                    </div>
                    {/* End Section Title */}
                </div>
            </div>
            <div className="row mb-30 pb-lg-1">
                <div className="col-lg-9 order-1 order-lg-0">
                    {/* Tab Buttons */}
                    <ul className="nav tab-buttons justify-content-center justify-content-lg-start">
                        <li>
                            <button className="select-rounded text-uppercase lg">Mark all read</button>
                        </li>
                        <li>
                            <button className="active select-rounded text-uppercase lg">All</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg">Following</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg">Purchased</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg">Liked</button>
                        </li>
                        <li>
                            <button className="select-rounded text-uppercase lg">Offered</button>
                        </li>
                    </ul>
                    {/* End Tab Buttons */}
                </div>
                <div className="col-lg-3 order-0 order-lg-1">
                    <div className="d-flex justify-content-center justify-content-lg-end mb-4 mb-lg-0">
                        <select className="select-rounded lg">
                            <option value="offers">Recent Active</option>
                            <option value="offers_received">Year 2016</option>
                            <option value="offers_made">Year 2017</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div className="table-responsive">
                        <table className="activity-table text-nowrap">
                            <tbody>
                                <tr className="unread">
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <img src="/img/media/tnft1.png" alt="Nft_Profile" />
                                            <span>AneftyPunks</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <span>Started following by: <span>Gayle Hicks</span></span>
                                    </td>
                                    <td><span>10 September, 2021. 2:06 PM</span></td>
                                    <td>
                                        <button className="btn-circle style--three">
                                            <img src="/img/icons/activity-icon1.svg" alt="" className="svg"/>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <img src="/img/media/tnft2.png" alt="Nft_Profile" />
                                            <span>KingzAnefty</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <span>1 Edition purchased by: <span>Stacy Long</span></span>
                                    </td>
                                    <td><span>12 September, 2021. 4:12 AM</span></td>
                                    <td>
                                        <button className="btn-circle style--three">
                                            <img src="/img/icons/activity-icon2.svg" alt="" className="svg"/>
                                        </button>
                                    </td>
                                </tr>
                                <tr className="unread">
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <img src="/img/media/tnft3.png" alt="Nft_Profile" />
                                            <span>NTFsBaAz</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <span>liked by: <span>Nicholas Daniels</span></span>
                                    </td>
                                    <td><span>14 September, 2021. 6:54 AM</span></td>
                                    <td>
                                        <button className="btn-circle style--three">
                                            <img src="/img/icons/activity-icon3.svg" alt="" className="svg"/>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <img src="/img/media/tnft4.png" alt="Nft_Profile" />
                                            <span>CyberKongz</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <span>offered 0.002 ETH by: <span>Franklin Greer</span></span>
                                    </td>
                                    <td><span>16 September, 2021. 8:26 AM</span></td>
                                    <td>
                                        <button className="btn-circle style--three">
                                            <img src="/img/icons/activity-icon4.svg" alt="" className="svg"/>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <NavLink to="product-details.html" className="product-wrapper">
                                            <img src="/img/media/tnft5.png" alt="Nft_Profile" />
                                            <span>CatsAnefty</span>
                                        </NavLink>
                                    </td>
                                    <td>
                                        <span>liked by: <span>Karla Sharp</span></span>
                                    </td>
                                    <td><span>18 September, 2021. 3:04 PM</span></td>
                                    <td>
                                        <button className="btn-circle style--three">
                                            <img src="/img/icons/activity-icon3.svg" alt="" className="svg"/>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-12 d-flex justify-content-center mt-4 mt-lg-5">
                    <NavLink to="#" className="btn"><img src="/img/icons/btn-loadmore.svg" alt="" className="svg"/>
                        Load
                        More</NavLink>
                </div>
            </div>
        </div>
    </section>
    {/* End Activity Feed */}
  
    </> 

  );
}

export default Activity;
